import style from "./ExampleBlock.module.scss";
import useLazyVideo from "../../../../utils/hooks/useLazyVideo";

function ExampleBlock({ dictionary }) {
    const [containerRef, videoRef, isInView] = useLazyVideo();

    return (
        <section className={style.container} ref={containerRef}>
            <div className={style.content}>
                <video ref={videoRef} className={style.video} autoPlay={isInView} loop muted playsInline preload="none" poster={"/image_editor/landing/poster.jpg"}>
                    <source src={"/image_editor/landing/video.mp4"} type="video/mp4" />
                </video>
                <div className={style.text}>
                    <h2 className={style.title}>{dictionary["page_editor_block2_header"] || "Use AI tools to create magic"}</h2>
                    <p className={style.description}>{dictionary["page_editor_block2_text"] || "Make artificial intelligence artwork from your photo with our Photo into Painting tool or remove unwanted object with Erase&Replace tool. Our AI makes magic acceptable for everyone."}</p>
                </div>
            </div>
        </section>
    );
}

export default ExampleBlock;